import { FC, useState } from 'react'
import DropdownMenuItemsGrid from '@/components/organisms/filter/dropdownMenuItemsGrid'
import useTranslation from 'next-translate/useTranslation'
import DropDownGridItem, { DropwDownGridItemSection } from './dropDownGridItem'
import { FilterSection } from '@/network/graphql.g'
import { FilterQueryItem } from '@/types/filterQueryItem'

type ManufacturerDesktopFilterProps = {
  manufacturers: FilterSection[]
  onManufacturerChange: (id: string, englishName: string) => void
  isInActiveFilters?: (id: string) => boolean
  onDiscardFilters?: () => void
  onClose?: () => void
  onConfirm?: (selectedIds: string[], typeDropDownItem: FilterQueryItem) => void
}

export enum sortBoostManufacturers {
  topPosition = 'product.manufacturer_top_brands',
  bottomPosition = 'product.manufacturer_another_brands'
}

const ManufacturerDesktopFilter: FC<ManufacturerDesktopFilterProps> = ({
  manufacturers,
  onManufacturerChange,
  isInActiveFilters,
  onClose,
  onDiscardFilters,
  onConfirm
}) => {
  const { t } = useTranslation('common')
  const [searchText, setSearchText] = useState<string>('')
  const filteredManufacturers = (): DropwDownGridItemSection[] => {
    const finalManufacturers =
      searchText.length === 0
        ? manufacturers
        : manufacturers.map(({ title, items }) => ({
            title,
            items: items.filter(({ title }) =>
              title.toLowerCase().includes(searchText.toLowerCase())
            )
          }))
    return finalManufacturers
      .map(({ id, title, items }) => {
        const mappedItems = items.map(({ id, title, count, englishName }) => ({
          id,
          title,
          count,
          isSelected: isInActiveFilters ? isInActiveFilters(id) : false,
          onSelect: () =>
            onManufacturerChange && onManufacturerChange(id, englishName)
        }))
        const sortedItems = [...mappedItems].sort((a, b) => {
          if (a.isSelected === b.isSelected) {
            return 0
          }
          return a.isSelected ? -1 : 1
        })

        return {
          id,
          title,
          items: sortedItems
        }
      })
      .sort((a, b) =>
        a.id === sortBoostManufacturers.topPosition
          ? -1
          : b.id === sortBoostManufacturers.bottomPosition
          ? 1
          : 0
      )
  }

  return (
    <DropdownMenuItemsGrid>
      <DropDownGridItem
        key={'manufacturers+grid'}
        sections={filteredManufacturers()}
        onClose={onClose}
        typeDropDownItem={FilterQueryItem.MANUFACTURER}
        onDiscard={onDiscardFilters}
        onConfirm={onConfirm}
        withSearch
        searchPlaceholder={t('Category.Filter.manufacturerSearchPlaceholder')}
        searchText={searchText}
        setSearchText={setSearchText}
      />
    </DropdownMenuItemsGrid>
  )
}

export default ManufacturerDesktopFilter
